<template>
    <div>
        <v-stepper-step :complete="currentStep > 2" step="3">
            <h3>Step 3</h3>
            <small style="padding-top:5px;">Details of redelivery/collection</small>
            <div v-show="currentStep == 3" class="text-caption">
                <p>
                    <span class="red--text"><strong>* </strong></span>= Mandatory field
                </p>
            </div>
        </v-stepper-step>
        <v-stepper-content step="3">
            <v-form v-model="deliveryAddressFormValid">
                <fieldset class="sr-only-fieldset">
                  <legend class="sr-only">Redelivery and collection information</legend>
                <v-container fluid>
                    <div class="input-wrapper">
                        <input id="stuff" hidden />
                        <label for="stuff" class="fa fa-exclamation input-icon"></label>
                    </div>

                    <v-col cols="12" md="6" v-if="this.keepAtPostOfficeRenewalPossible && !keepAtPostOfficeRenewAllItems">
                        <v-subheader class="pl-0">
                            One or more of the items cannot be redelivered because they are already being kept at post office. <br />Please re-enter barcodes separately.
                        </v-subheader>
                        <v-spacer></v-spacer>
                    </v-col>

                    <div v-if="!this.keepAtPostOfficeRenewalPossible || keepAtPostOfficeRenewAllItems">

                        <v-col cols="12" md="6">
                            Applicable Fees <v-btn icon x-small aria-label="View applicable fees information" @click="showFeesDialog = true"><v-icon>mdi-information-outline</v-icon></v-btn>
                        </v-col>

                        <v-col cols="12" md="6">
                            <fieldset class="sr-only-fieldset">
                                <legend class="sr-only">Choose a delivery or collection option</legend>
                                <v-radio-group v-model="deliveryAddress.type" :rules="deliveryAddressRules">
                                    <v-row v-if="!this.keepAtPostOfficeRenewalPossible">
                                        <v-col>
                                            <v-radio label="Deliver item(s) to an address" :value="deliveryTypes.ADDRESS"></v-radio>
                                        </v-col>
                                    </v-row>
                                    <v-row v-if="!this.keepAtPostOfficeRenewalPossible && this.isRedeliveryToLockerPossible">
                                        <v-col>
                                            <v-radio label="Collect item(s) from EasiPik locker"
                                                     :value="deliveryTypes.LOCKER"
                                                     @click="showRedeliveryToLockerDialog = true"
                                                     aria-haspopup="dialog"></v-radio>
                                        </v-col>
                                    </v-row>
                                    <v-row v-if="!this.keepAtPostOfficeRenewalPossible">
                                        <v-col>
                                            <v-radio label="Collect item(s) from Post Office" :value="deliveryTypes.POSTOFFICE"></v-radio>
                                        </v-col>
                                    </v-row>
                                    <v-row v-if="this.keepAtPostOfficePossible || this.keepAtPostOfficeRenewAllItems">
                                        <v-col>
                                            <v-radio label="Keep item(s) at Post Office"
                                                     :value="deliveryTypes.KEEPITEMS"
                                                     @click="showKeepAtPostOfficeDialog = true"
                                                     aria-haspopup="dialog"></v-radio>
                                        </v-col>
                                    </v-row>
                                    <template #label>
                                        <strong class="black--text" style="font-size:14px">
                                            <span class="red--text"><strong>* </strong></span>Delivery/Collection:
                                            <span class="sr-only"> (required)</span>
                                        </strong>
                                    </template>
                                </v-radio-group>
                            </fieldset>
                        </v-col>

                    </div>

                </v-container>

                <template>
                    <div class="text-center">
                        <v-dialog v-model="showFeesDialog" width="600">

                            <v-card>
                                <v-card-title class="text-h5 grey lighten-2">
                                    Applicable Fees

                                    <v-spacer></v-spacer>
                                    <v-btn icon @click="showFeesDialog = false" aria-label="Close">
                                        <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                </v-card-title>

                                <v-card-text style="line-height: 30px;">
                                    <table class="fees-table" border="1" cellspacing="0" bordercolor="darkgray">
                                        <caption class="sr-only">Applicable redelivery and collection fees by item quantity</caption>
                                        <thead>
                                            <tr>
                                                <th rowspan="2" colspan="2" scope="col"><b>Applicable Fees</b></th>
                                                <th colspan="3" scope="colgroup" class="fees-header-cell">Item Quantity</th>
                                            </tr>
                                            <tr>
                                                <th scope="col" class="fees-header-cell">1</th>
                                                <th scope="col" class="fees-header-cell">2</th>
                                                <th scope="col" class="fees-header-cell">3</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <th rowspan="2" scope="rowgroup" style="padding-right: 50px;">Second delivery by courier to your <b>specified address</b></th>
                                                <th scope="row">Tracked (barcoded)</th>
                                                <td>&euro;5.50</td>
                                                <td>&euro;7.50</td>
                                                <td>&euro;9.50</td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Untracked (not barcoded)<sup>*</sup></th>
                                                <td>&euro;4.00</td>
                                                <td>&euro;5.50</td>
                                                <td>&euro;7.00</td>
                                            </tr>
                                            <tr>
                                                <th colspan="2" scope="row">Collection of item from an alternative <b>(Sub) Post Office</b></th>
                                                <td>&euro;3.00</td>
                                                <td>&euro;4.00</td>
                                                <td>&euro;5.00</td>
                                            </tr>
                                            <tr>
                                                <th rowspan="2" scope="rowgroup">Collection of item from your preferred <b>Easipik locker</b></th>
                                                <th scope="row">Local Registered<sup>**</sup> item located in same Post Office as locker</th>
                                                <td>FOC</td>
                                                <td>FOC</td>
                                                <td>FOC</td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Rest</th>
                                                <td>&euro;2.00</td>
                                                <td>&euro;3.00</td>
                                                <td>&euro;4.00</td>
                                            </tr>
                                            <tr>
                                                <th colspan="2" scope="row">Holding of packet/letter<sup>***</sup></th>
                                                <td>&euro;5.00</td>
                                                <td>&euro;7.50</td>
                                                <td>&euro;10.00</td>
                                            </tr>
                                            <tr>
                                                <td colspan="5" class="fees-footer-cell">FOC = free of charge</td>
                                            </tr>
                                            <tr>
                                                <td colspan="5" class="fees-footer-cell"><sup>*</sup> also referred to as Bulky</td>
                                            </tr>
                                            <tr>
                                                <td colspan="5" class="fees-footer-cell"><sup>**</sup> Local registered items with prefix RH, RR, RT and RI and suffix MT</td>
                                            </tr>
                                            <tr>
                                                <td colspan="5" class="fees-footer-cell"><sup>***</sup> The rates are rounded to the nearest week</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </v-card-text>

                            </v-card>
                        </v-dialog>
                    </div>
                </template>

                <template>
                    <div class="text-center">
                        <v-dialog v-model="showKeepAtPostOfficeDialog"
                                  width="600"
                                  persistent>

                            <v-card>
                                <v-card-title class="text-h5 grey lighten-2">Confirm</v-card-title>
                                <v-card-text style="line-height: 30px;">
                                    <div v-if="this.keepAtPostOfficePossible && !this.keepAtPostOfficeRenewalPossible && this.keepAtPostOfficeAllAtSamePO && parcelType === parcelTypes.Tracked">
                                        Please confirm that the items are to be kept at the specified post office.
                                    </div>
                                    <div v-if="this.keepAtPostOfficePossible && this.keepAtPostOfficeRenewalPossible && this.keepAtPostOfficeAllAtSamePO && parcelType === parcelTypes.Tracked">
                                        Please confirm that you would like to extend the number of days items should be kept at the specified post office.
                                    </div>
                                    <div v-if="this.keepAtPostOfficePossible && !this.keepAtPostOfficeRenewalPossible && this.keepAtPostOfficeAllAtSamePO && parcelType === parcelTypes.Untracked">
                                        Please confirm that you would like to keep an untracked item at a post office.
                                    </div>
                                    <div v-if="this.keepAtPostOfficePossible && this.keepAtPostOfficeRenewalPossible && this.keepAtPostOfficeAllAtSamePO && parcelType === parcelTypes.Untracked">
                                        Please confirm that you would like to extend the number of days your untracked items should be kept at a post office.
                                    </div>
                                    <div v-if="!this.keepAtPostOfficePossible && this.keepAtPostOfficeAllAtSamePO">
                                        One or more of the items cannot be kept at a post office.
                                    </div>
                                    <div v-if="!this.keepAtPostOfficeAllAtSamePO">
                                        The items are at different post offices. Please create one request for each item.
                                    </div>
                                    <v-container v-for="item in this.trackingNumbersEligibleForRedelivery" :key="item.trackingNumber" class="summaryBox">
                                        <v-row class="summaryRow" :class="[!item.canBeKeptAtPostOffice ? 'tracked-item-not-found' : '']" no-gutters>
                                            <v-col cols="12" sm="4">Tracking Number</v-col>
                                            <v-col cols="12" sm="4">{{ item.trackingNumber}}</v-col>
                                            <v-col cols="12" sm="4">{{ item.canBeKeptAtPostOffice ? item.postOfficeName : "The request for barcode "+item.trackingNumber+" cannot be handled. Please contact Customer Care." }}</v-col>
                                        </v-row>
                                    </v-container>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn v-if="this.keepAtPostOfficePossible" @click="showKeepAtPostOfficeDialog = false">Confirm</v-btn>
                                    <v-btn @click="showKeepAtPostOfficeDialog = false; deliveryAddress.type = null">Cancel</v-btn>
                                    <v-spacer></v-spacer>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </div>
                </template>

                <template>
                    <div class="text-center">
                        <v-dialog v-model="showRedeliveryToLockerDialog" v-if="!this.allItemsCanBeRedeliveredToLocker"
                                  width="600"
                                  persistent>

                            <v-card>
                                <v-card-title class="text-h5 grey lighten-2">Confirm</v-card-title>
                                <v-card-text style="line-height: 30px;">
                                    <div class="summaryBox">

                                        <v-container v-for="item in this.itemsAllowedForRedeliveryToLocker" :key="item.trackingNumber">
                                            <v-row class="summaryRow" no-gutters>
                                                <v-col cols="12" sm="4">Tracking Number</v-col>
                                                <v-col cols="12" sm="4">{{item}}</v-col>
                                                <v-col cols="12" sm="4">Item may be redelivered to an EP locker.</v-col>
                                            </v-row>
                                        </v-container>

                                        <v-container v-for="item in this.itemsNotAllowedForRedeliveryToLocker" :key="item.trackingNumber">
                                            <v-row class="summaryRow" :class="[!item.eligibleForRedeliveryToLocker ? 'tracked-item-not-found' : '']" no-gutters>
                                                <v-col cols="12" sm="4">Tracking Number</v-col>
                                                <v-col cols="12" sm="4">{{item}}</v-col>
                                                <v-col cols="12" sm="4">Item cannot be redelivered to an EP locker. Please resubmit with another redelivery option.</v-col>
                                            </v-row>
                                        </v-container>

                                    </div>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn @click="showRedeliveryToLockerDialog = false; deliveryAddress.type = null">Confirm</v-btn>
                                    <v-spacer></v-spacer>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </div>
                </template>

                <v-container v-if="deliveryAddress.type && deliveryAddress.type == deliveryTypes.ADDRESS" style="margin: 0;">

                    <template>
                        <div>
                            <v-subheader id="delivery-address-instructions" class="pl-0">
                                Search for your address using the address finder or enter it manually below.
                            </v-subheader>
                            <label class="sr-only" for="delivery-address-search">
                                Search by Postcode, Locality, House number, House name, etc.
                            </label>

                            <v-card class="mb-4">
                                <v-card-text class="pt-0 pb-2">
                                    <v-autocomplete
                                        id="delivery-address-search"
                                        v-model="selectedAddress"
                                        :items="addressItems"
                                        :loading="isLoadingAddressData"
                                        :search-input.sync="search"
                                        :menu-props="autocompleteMenuProps"
                                        :messages="showApiError ? [' '] : []"
                                        :hide-no-data="!showNoData"
                                        item-text="Description"
                                        placeholder="Search by Postcode, Locality, House number, House name, etc..."
                                        aria-label="Search by Postcode, Locality, House number, House name, etc."
                                        aria-describedby="delivery-address-instructions"
                                        return-object
                                        clearable
                                        >
                                        <template v-slot:prepend-inner>
                                            <div class="d-flex align-center">
                                            <v-icon v-if="!isLoadingAddressData">mdi-magnify</v-icon>
                                            <v-progress-circular v-else indeterminate size="20" color="primary" />
                                            </div>
                                        </template>

                                        <template v-slot:message>
                                            <div v-if="showApiError" class="d-flex align-center error--text pa-2">
                                            <span style="font-size: 1rem; font-weight: 500;">
                                                {{ apiError.message }}
                                            </span>
                                            </div>
                                        </template>

                                        <template v-slot:no-data>
                                            <div class="text-caption grey--text pa-2">
                                            {{ noDataText }}
                                            </div>
                                        </template>
                                    </v-autocomplete>
                                </v-card-text>
                            </v-card>
                        </div>
                    </template>

                    <v-col cols="12" md="4">
                        <v-autocomplete :items="localities" label="Locality" item-text="name" item-value="id"
                                        placeholder="Select a locality" v-model="deliveryAddress.localityId" required :rules="localityRules"
                                        aria-required="true"
                                        @change="updateDeliveryAddressLocality">
                            <template #label>
                                <strong class="black--text">
                                    <span class="red--text"><strong>* </strong></span>Locality:
                                    <span class="sr-only"> (required)</span>
                                </strong>
                            </template>
                        </v-autocomplete>
                    </v-col>


                    <v-col cols="12" md="4">
                        <v-text-field v-model="deliveryAddress.streetName" :rules="streetNameRules" :counter="50"
                                      label="DeliveryAddressStreetName" placeholder="Street Name" required aria-required="true"
                                      :aria-describedby="'delivery-street-counter'">
                            <template #label>
                                <strong class="black--text">
                                    <span class="red--text"><strong>* </strong></span>Street Name:
                                    <span class="sr-only"> (required)</span>
                                </strong>
                            </template>
                            <template v-slot:append-outer>
                                <span id="delivery-street-counter" class="sr-only">
                                    {{ deliveryAddress.streetName ? deliveryAddress.streetName.length : 0 }} of 50 characters used
                                </span>
                            </template>
                        </v-text-field>
                    </v-col>

                    <v-col cols="12" md="4">
                        <v-text-field v-model="deliveryAddress.houseNameNumber" :rules="houseNameNumberRules" :counter="50"
                                      label="DeliveryAddressHouseNameNumber" placeholder="House Name / Number" required aria-required="true"
                                      :aria-describedby="'delivery-house-counter'">
                            <template #label>
                                <strong class="black--text">
                                    <span class="red--text"><strong>* </strong></span>House Name / Number:
                                    <span class="sr-only"> (required)</span>
                                </strong>
                            </template>
                            <template v-slot:append-outer>
                                <span id="delivery-house-counter" class="sr-only">
                                    {{ deliveryAddress.houseNameNumber ? deliveryAddress.houseNameNumber.length : 0 }} of 50 characters used
                                </span>
                            </template>
                        </v-text-field>
                    </v-col>

                    <v-col cols="12" md="4">
                        <v-text-field v-model="deliveryAddress.postCode" :rules="postCodeRules" label="DeliveryAddressPostCode"
                                      placeholder="Post Code" required aria-required="true">
                            <template #label>
                                <strong class="black--text">
                                    <span class="red--text"><strong>* </strong></span>Post Code:
                                    <span class="sr-only"> (required)</span>
                                </strong>
                            </template>
                        </v-text-field>
                    </v-col>
                </v-container>

                <v-container v-if="deliveryAddress.type && deliveryAddress.type == deliveryTypes.LOCKER" style="margin: 0;">
                    <v-col cols="12" md="4" lg="5" style="padding-bottom:0px">
                        <v-text-field v-model="deliveryAddress.easipikCustomerCode" :rules="easipikCustomerCodeRules" :counter="8"
                                      label="EasipikCustomerCode" placeholder="Easipik Customer Code" required aria-required="true"
                                      :aria-describedby="'easipik-customer-code-counter'" @input="clearParceLocker"
                                      @change="fetchEasiPikCustomerDetails">
                            <template #label>
                                <strong class="black--text">
                                    <span class="red--text"><strong>* </strong></span>EasiPik Customer Code:
                                    <span class="sr-only"> (required)</span>
                                </strong>
                            </template>
                            <template v-slot:append-outer>
                                <span id="easipik-customer-code-counter" class="sr-only">
                                    {{ deliveryAddress.easipikCustomerCode ? deliveryAddress.easipikCustomerCode.length : 0 }} of 8 characters used
                                </span>
                            </template>
                        </v-text-field>
                    </v-col>

                    <v-col cols="12" md="4" lg="5" style="padding-top:0px">
                        <small>
                            Customer code is obtained by logging in to your <a href="https://www.maltapost.com/easipikdeliveries#/login"
                                                                               target="_blank">Easipik account<span class="sr-only"> (opens in a new tab)</span></a>.
                            Should you wish to register, kindly proceed to <a href="https://www.maltapost.com/easipik"
                                                                              target="_blank">www.maltapost.com/easipik<span class="sr-only"> (opens in a new tab)</span></a>.
                        </small>
                    </v-col>

                    <div v-show="deliveryAddress.parcelLocker !== null && deliveryAddress.easipikCustomerCode !== ''"
                         style="margin-left:15px">
                        <v-row>
                            <v-col cols="12" md="4" lg="5" style="padding-bottom:0px">
                                <v-text-field label="Your default locker is:" v-model="deliveryAddress.parcelLocker"
                                              :rules="parcelLockerRules" :readonly="true" required aria-required="true">
                                    <template #label>
                                        <strong class="black--text">
                                            <span class="red--text"><strong>* </strong></span>Your default locker is:
                                            <span class="sr-only"> (required)</span>
                                        </strong>
                                    </template>
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" md="4" lg="5" style="padding-bottom:0px">
                                <v-btn color="primary" @click="fetchEasiPikCustomerDetails">
                                    Refresh Default Locker
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="4" lg="5" style="padding-top:0px">
                                <small>
                                    If the item is to be delivered to a different locker than your above displayed default,
                                    kindly log on to your <a href="https://www.maltapost.com/easipikdeliveries#/login"
                                                                             target="_blank">Easipik account<span class="sr-only"> (opens in a new tab)</span></a>,
                                    go to My Account, choose the new Default Parcel Locker and click on Save.
                                    Wait for a while, then press the above "Refresh Default Locker" button to continue with this form.
                                </small>
                            </v-col>
                        </v-row>
                    </div>
                </v-container>

                <v-container v-if="deliveryAddress.type && deliveryAddress.type == deliveryTypes.POSTOFFICE" style="margin: 0;">
                    <v-col cols="12" md="4">
                        <v-select :items="postOffices" label="Post Office" item-text="name" item-value="id"
                                  placeholder="Select post office" v-model="deliveryAddress.postOfficeId" required aria-required="true" :rules="postOfficeRules">
                            <template #label>
                                <strong class="black--text">
                                    <span class="red--text"><strong>* </strong></span>Post Office:
                                    <span class="sr-only"> (required)</span>
                                </strong>
                            </template>
                        </v-select>
                    </v-col>
                </v-container>

                <v-container v-if="deliveryAddress.type && deliveryAddress.type == deliveryTypes.KEEPITEMS && !showKeepAtPostOfficeDialog" style="margin: 0;">
                    <v-col cols="12" sm="6" md="4">
                        <v-menu v-model="dpMenu" :close-on-content-click="false" :nudge-left="20" transition="scale-transition"
                                offset-y min-width="auto" required>
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-model="keepAtPostOfficeTill" readonly v-bind="attrs" v-on="on" ref="dateField"
                                              @keydown.enter.native="dpOpenMenu"
                                              @keydown.space.native="dpOpenMenu"
                                              placeholder="Keep at post office until" :rules="keepAtPostOfficeTillDateRules"
                                              aria-haspopup="dialog">
                                    <template #label>
                                        <strong class="black--text">
                                            <span class="red--text"><strong>* </strong></span>Keep at post office until:
                                            <span class="sr-only"> (required)</span>
                                        </strong>
                                    </template>
                                    <template v-slot:append>
                                        <v-btn icon small
                                            aria-label="Choose date"
                                            aria-haspopup="dialog"
                                            :aria-expanded="dpMenu ? 'true' : 'false'"
                                            @click="dpOpenMenu"
                                            @keydown.enter.native="dpOpenMenu"
                                            @keydown.space.native="dpOpenMenu">
                                            <v-icon>mdi-calendar</v-icon>
                                        </v-btn>
                                    </template>
                                </v-text-field>
                            </template>
                            <v-date-picker v-model="keepAtPostOfficeTill" ref="datePicker" :picker-date.sync="dpPickerDate" :active-picker.sync="dpActivePicker" @input="dpOnSelect" @keydown.native="onDatePickerKeydown" :allowed-dates="disableOutOfRangeDates" required>
                            </v-date-picker>
                        </v-menu>
                    </v-col>

                </v-container>

                </fieldset>
            </v-form>
            <v-btn color="primary" @click="goNext()" :disabled="!deliveryAddressFormValid" :aria-disabled="!deliveryAddressFormValid">
                Next
            </v-btn>
            <div class="sr-only" aria-live="polite" v-if="!deliveryAddressFormValid">
                Please complete all required redelivery or collection fields to proceed.
            </div>
            <v-btn text @click="currentStep = 2"> Back </v-btn>
        </v-stepper-content>
    </div>
</template>


<script>
    import validationRules from "../../helpers/ValidationRules";
    import { createNamespacedHelpers } from "vuex";
    import axios from "axios";
    import { combineURLs } from "../../helpers/UrlHelpers";
    import deliveryTypes from "../../constants/deliveryTypes";
    import parcelTypes from "../../constants/parcelTypes";
    import _ from "lodash";
    import accessibleDatePicker from "../../mixins/accessibleDatePicker";

    const { mapGetters: mapMissedDeliveryGetters } = createNamespacedHelpers(
        "missedDelivery"
    );

    export default {
        name: "Step03",
        mixins: [accessibleDatePicker],
        data() {
            return {
                ...validationRules,
                deliveryTypes: deliveryTypes,
                parcelTypes: parcelTypes,
                deliveryAddressFormValid: false,
                dataPreloadedFromDb: false,
                deliveryAddress: {
                    type: null,
                    parcelLocker: null,
                    parcelLockerId: null,
                    easipikCustomerCode: "",
                    postOffice: null,
                    postOfficeId: null,
                    locality: null,
                    localityId: null,
                    streetName: "",
                    houseNameNumber: "",
                    postCode: "",
                    keepAtPostOfficeFrom: null,
                    keepAtPostOfficeTill: null,
                },
                addressSearchResults: [],
                search: null,
                selectedAddress: null,
                isLoadingAddressData: false,
                showFeesDialog: false,
                showKeepAtPostOfficeDialog: false,
                showRedeliveryToLockerDialog: false,
                keepAtPostOfficeTill: null,
                dpMenu: false,
                searchAttempted: false,
                apiError: { show: false, message: "", code: null },
                lastQuery: "",
                abortController: null,
            };
        },
        computed: {
            ...mapMissedDeliveryGetters(["localities", "parcelLockers", "postOffices", "keepAtPostOfficeInformation", "redeliveryToLockerInformation", "trackingNumbersEligibleForRedelivery"]),
            ...mapMissedDeliveryGetters({
                loadedNotice: "Step01/notice",
                loadedDeliveryAddress: "Step03/deliveryAddress"
            }),
            currentStep: {
                set(currentStep) {
                    this.$store.dispatch("missedDelivery/setCurrentStep", currentStep);
                },
                get() {
                    const stepNumber = this.$store.getters["missedDelivery/currentStep"];
                    return stepNumber;
                },
            },
            parcelType: {
                get() {
                    return this.loadedNotice.parcelType;
                }
            },
            showApiError() {
                return this.apiError?.show && !this.isLoadingAddressData;
            },
            showNoData() {
                return (
                this.searchAttempted &&
                !this.isLoadingAddressData &&
                !this.apiError?.show &&
                (this.addressItems?.length ?? 0) === 0
                );
            },
            noDataText() {
                return this.lastQuery
                ? `No search results found for "${this.lastQuery}"`
                : "No search results found";
            },
            addressItems() {
                return this.addressSearchResults.map((entry) => {
                    var addrLine1 = [
                        entry.houseNo,
                        entry.houseName,
                        entry.houseAlpha,
                        entry.flatNo,
                    ]
                        .join(" ")
                        .trim();
                    var Description =
                        addrLine1 + ", " +
                        entry.street + ", " +
                        entry.locality + " " +
                        entry.postCode + ", " +
                        entry.country;
                    return Object.assign({}, entry, { Description, addrLine1 });
                });
            },
            autocompleteMenuProps() {
                // default properties copied from the vuetify-autocomplete docs
                let defaultProps = {
                    closeOnClick: false,
                    closeOnContentClick: false,
                    disableKeys: true,
                    openOnClick: false,
                    maxHeight: 304,
                    offsetY: true,
                    offsetOverflow: true,
                    transition: false,
                };

                if (this.$vuetify.breakpoint.smAndDown) {
                    defaultProps.maxHeight = 185;
                }

                return defaultProps;
            },
            keepAtPostOfficePossible() {
                return this.keepAtPostOfficeInformation && this.keepAtPostOfficeInformation.allowed;
            },
            keepAtPostOfficeRenewalPossible() {
                return this.keepAtPostOfficeInformation && this.keepAtPostOfficeInformation.someItemsAreEligibleForKeepAtPORenewal;
            },
            keepAtPostOfficeRenewAllItems() {
                return this.keepAtPostOfficeInformation && this.keepAtPostOfficeInformation.allItemsAreEligibleForKeepAtPORenewal
            },
            keepAtPostOfficeAllAtSamePO() {
                return this.keepAtPostOfficeInformation && !this.keepAtPostOfficeInformation.itemsAtDifferentPostOffices;
            },
            isRedeliveryToLockerPossible() {
                return this.parcelType === parcelTypes.Untracked || (this.redeliveryToLockerInformation && this.redeliveryToLockerInformation.allowed);
            },
            allItemsCanBeRedeliveredToLocker() {
                if (this.redeliveryToLockerInformation && this.redeliveryToLockerInformation.itemsNotAllowedForRedeliveryToLocker)
                    return Object.keys(this.redeliveryToLockerInformation.itemsNotAllowedForRedeliveryToLocker).length === 0

                return true;
            },
            itemsNotAllowedForRedeliveryToLocker() {
                return this.redeliveryToLockerInformation && this.redeliveryToLockerInformation.itemsNotAllowedForRedeliveryToLocker;
            },
            itemsAllowedForRedeliveryToLocker() {
                return this.redeliveryToLockerInformation && this.redeliveryToLockerInformation.itemsAllowedForRedeliveryToLocker;
            }
        },
        watch: {
            loadedDeliveryAddress() {
                if (Object.keys(this.loadedDeliveryAddress).length !== 0 && !this.dataPreloadedFromDb) {
                    this.deliveryAddress = { ...this.loadedDeliveryAddress }; //make a "deep" copy
                    this.dataPreloadedFromDb = true;
                }
            },
            search: _.debounce(function (val) {
                if (!val) {
                this.addressSearchResults = [];
                this.apiError = { show: false, message: "", code: null };
                this.searchAttempted = false; // <- add this
                return;
                }
                if (!this.selectedAddress || val !== this.selectedAddress.Description) {
                this.lastQuery = val;
                this.fetchAddresses(val);
                }
            }, 500),
            selectedAddress(newSelectedAddress) {
                if (newSelectedAddress != null) {
                    this.deliveryAddress.houseNameNumber = newSelectedAddress.addrLine1;
                    this.deliveryAddress.streetName = newSelectedAddress.street;
                    this.deliveryAddress.postCode = newSelectedAddress.postCode;

                    const selectedLocality = this.localities.find((l) =>
                        l.localityNameOnly.toUpperCase() === newSelectedAddress.locality.toUpperCase() &&
                        l.region.toUpperCase() === newSelectedAddress.country.toUpperCase()
                    );

                    if (selectedLocality) {
                        this.deliveryAddress.localityId = selectedLocality.id;
                        this.deliveryAddress.locality = selectedLocality.name;
                    }
                }
            }
        },  
        beforeDestroy() {
            if (this.abortController) this.abortController.abort();
        },
        methods: {
            
            retrySearch() {
                if (this.lastQuery && !this.isLoadingAddressData) {
                    this.fetchAddresses(this.lastQuery);
                }
            },

            async fetchAddresses(query) {
                if (this.abortController) this.abortController.abort();
                this.abortController = new AbortController();

                this.isLoadingAddressData = true;
                this.apiError = { show: false, message: "", code: null };
                this.searchAttempted = false; // reset before request
                this.lastQuery = query;

                try {
                    const url = combineURLs(
                    process.env.VUE_APP_ADDRESS_FINDER_API_BASE_URL,
                    `/v1/address/search?query=${encodeURIComponent(query)}&maxresult=15`
                    );

                    const res = await axios.get(url, {
                        signal: this.abortController.signal,
                        timeout: 10000,
                        validateStatus: (s) => (s >= 200 && s < 300) || s === 404,
                    });

                    this.addressSearchResults = res.status === 404
                    ? []
                    : Array.isArray(res.data) ? res.data : [];

                    this.searchAttempted = true;
                } catch (err) {
                    // ignore cancels
                    if (axios.isCancel?.(err) || err?.name === "CanceledError" || err?.name === "AbortError") return;

                    this.addressSearchResults = [];
                    this.searchAttempted = true; // a search did occur, but failed

                    const status = err?.response?.status ?? null;
                    const statusText = err?.response?.statusText ?? "";
                    const data = err?.response?.data;
                    const serverMsg =
                    (typeof data === "string" && data) ||
                    data?.message || data?.error || data?.title || data?.detail || null;

                    const code = err?.code ?? (status ? `HTTP_${status}` : null);

                    const friendly =
                    status
                        ? `Error ${status}${statusText ? ` ${statusText}` : ""}${serverMsg ? ` - ${serverMsg}` : ""}`
                        : (code === "ECONNABORTED"
                            ? "Request timed out. Please try again."
                            : "Something went wrong. Please try again, or complete the form below instead.");

                    this.apiError = { show: true, message: friendly, code };
                } finally {
                    this.isLoadingAddressData = false;
                }
                },
            dpGetValue() {
                return this.keepAtPostOfficeTill;
            },
            dpFieldLabel() {
                return "Keep at post office until";
            },
            disableOutOfRangeDates(val) {
                var date = new Date(val).setHours(0, 0, 0, 0);
                var upperLimit = new Date(this.keepAtPostOfficeInformation.latest).setHours(0, 0, 0, 0);
                var lowerLimit = new Date(this.keepAtPostOfficeInformation.earliest).setHours(0, 0, 0, 0);
                return (date <= upperLimit && date >= lowerLimit) && !this.keepAtPostOfficeInformation.nonWorkingDaysAndHolidays.some(n => {
                    var notAllowedDay = new Date(n).setHours(0, 0, 0, 0);
                    return notAllowedDay == date;
                });
            },
            async goNext() {

                if (this.deliveryAddress.type === deliveryTypes.KEEPITEMS && this.keepAtPostOfficeTill) {
                    this.deliveryAddress.atPostOfficeSince = this.keepAtPostOfficeInformation.atPostOfficeSince;
                    this.deliveryAddress.keepAtPostOfficeFrom = new Date(this.keepAtPostOfficeInformation.earliest);
                    this.deliveryAddress.keepAtPostOfficeTill = new Date(this.keepAtPostOfficeTill);
                    this.deliveryAddress.postOfficeId = this.keepAtPostOfficeInformation.postOfficeId
                } else {
                    this.deliveryAddress.atPostOfficeSince = null;
                    this.deliveryAddress.keepAtPostOfficeFrom = null;
                    this.deliveryAddress.keepAtPostOfficeTill = null;
                }

                this.$store.dispatch("missedDelivery/Step03/setDeliveryAddress", this.deliveryAddress);
                this.$store.dispatch("missedDelivery/saveRequest");
            },
            updateDeliveryAddressLocality(localityId) {
                var locality = this.localities.find(function (l) { return l.id === localityId; });
                this.deliveryAddress.locality = locality.name;
            },
            clearParceLocker() {
                this.deliveryAddress.parcelLockerId = null;
                this.deliveryAddress.parcelLocker = null;
            },
            async fetchEasiPikCustomerDetails() {

                let isValid = true;
                this.easipikCustomerCodeRules.forEach(v => isValid &= v(this.deliveryAddress.easipikCustomerCode) === true);
                if (isValid) {
                    this.deliveryAddress.parcelLockerId = null;
                    this.deliveryAddress.parcelLocker = null;

                    const result = await this.$store.dispatch("missedDelivery/verifyEasipikCustomerCode", this.deliveryAddress.easipikCustomerCode)

                    if (result.customerFound) {
                        this.deliveryAddress.parcelLockerId = result.defaultEasiPikLockerId;
                        this.deliveryAddress.parcelLocker = this.parcelLockers.find(pl => pl.id === result.defaultEasiPikLockerId).name;
                    } else {
                        this.deliveryAddress.easipikCustomerCode = "";
                    }
                }
            }
        },
    };
</script>

<style>
    .v-file-input .v-input__prepend-outer {
        margin-right: 0 !important;
    }

    .tracked-item-not-found {
        color: #b71c1c
    }

    .fees-table th, .fees-table td {
        padding: 20px 10px;
        margin-top: 25px;
    }

    .fees-header-cell {
        padding-top: 1px !important;
        padding-bottom: 1px !important;
    }

    .fees-footer-cell {
        padding-top: 0px !important;
        padding-bottom: 0px !important;
    }
</style>
